// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideNavOperator {
    justify-content: center;
}

.dynSideNav {
    margin: 0px 1px 1px 0px;
}

.sideNavIcon {
    cursor: default;
}

.scroll {
    overflow: auto;
}

.details > * {
    flex: 1 1 50%;
}

.marginL10 {
    margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/containertable/containertable.settings.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".sideNavOperator {\n    justify-content: center;\n}\n\n.dynSideNav {\n    margin: 0px 1px 1px 0px;\n}\n\n.sideNavIcon {\n    cursor: default;\n}\n\n.scroll {\n    overflow: auto;\n}\n\n.details > * {\n    flex: 1 1 50%;\n}\n\n.marginL10 {\n    margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
